(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/nav-menu/assets/javascripts/nav-menu.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/nav-menu/assets/javascripts/nav-menu.js');

'use strict';

const uiMockable = svs.ui;
const lbUtilsMockable = svs.components.lbUtils;
const _ReactRouterDOM = ReactRouterDOM,
  Link = _ReactRouterDOM.Link;
const NavMenu = props => {
  const _ref = props || {},
    menuItems = _ref.menuItems,
    _ref$branding = _ref.branding,
    branding = _ref$branding === void 0 ? 'sport' : _ref$branding,
    relativeTo = _ref.relativeTo;
  const renderMenuItems = menuItems => menuItems.map(item => React.createElement(React.Fragment, {
    key: item.to.pathname
  }, React.createElement(lbUtilsMockable.linkItemRoute.LinkItemRoute, {
    "aria-label": item.ariaLabel,
    Component: Link,
    icon: item.icon,
    iconSize: "400",
    key: item.to.pathname,
    label: item.label,
    relativeTo: relativeTo,
    selectedOnPaths: item.selectedOnPaths,
    to: item.to
  })));
  return React.createElement("div", {
    className: "competition-nav-menu",
    "data-testid": "qa-competition-menu"
  }, React.createElement(uiMockable.ReactPaper, {
    branding: "sport",
    className: "padding-sm-h-3"
  }, React.createElement(uiMockable.ReactItemsMenu.ItemsMenu, {
    branding: branding,
    centered: true,
    customer: "sport",
    hiddenScrollbar: true
  }, renderMenuItems(menuItems))));
};
setGlobal('svs.components.marketplaceCompetition.navMenu.NavMenu', NavMenu);

 })(window);